'use client';

import _defineProperty from "/codebuild/output/src1641/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getThemeStyles } from './get-theme-styles/get-theme-styles.mjs';
import { resolveStyle } from './resolve-style/resolve-style.mjs';
import { resolveStyles } from './resolve-styles/resolve-styles.mjs';
import { resolveVars } from './resolve-vars/resolve-vars.mjs';
function getStyle(_ref) {
  var theme = _ref.theme,
    themeName = _ref.themeName,
    selector = _ref.selector,
    options = _ref.options,
    props = _ref.props,
    stylesCtx = _ref.stylesCtx,
    rootSelector = _ref.rootSelector,
    styles = _ref.styles,
    style = _ref.style,
    vars = _ref.vars,
    varsResolver = _ref.varsResolver,
    headless = _ref.headless,
    withStylesTransform = _ref.withStylesTransform;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !withStylesTransform && getThemeStyles({
    theme: theme,
    themeName: themeName,
    props: props,
    stylesCtx: stylesCtx,
    selector: selector
  })), !withStylesTransform && resolveStyles({
    theme: theme,
    styles: styles,
    props: props,
    stylesCtx: stylesCtx
  })[selector]), !withStylesTransform && resolveStyles({
    theme: theme,
    styles: options === null || options === void 0 ? void 0 : options.styles,
    props: (options === null || options === void 0 ? void 0 : options.props) || props,
    stylesCtx: stylesCtx
  })[selector]), resolveVars({
    theme: theme,
    props: props,
    stylesCtx: stylesCtx,
    vars: vars,
    varsResolver: varsResolver,
    selector: selector,
    themeName: themeName,
    headless: headless
  })), rootSelector === selector ? resolveStyle({
    style: style,
    theme: theme
  }) : null), resolveStyle({
    style: options === null || options === void 0 ? void 0 : options.style,
    theme: theme
  }));
}
export { getStyle };